import "@dotlottie/player-component";

export type LottieProps = {
  height?: number;
  width?: number;
  src?: object;
};

export default function Lottie(props: LottieProps) {
  const { height, width, src } = props;

  return (
    <>
      <dotlottie-player src={src} autoplay loop style={{ width: `${width}px`, height: `${height}px` }} />
    </>
  );
}
